import script from "./KnowledgeBaseDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./KnowledgeBaseDialog.vue?vue&type=script&lang=ts&setup=true"

import "./KnowledgeBaseDialog.vue?vue&type=style&index=0&id=7cd75292&lang=scss"

const __exports__ = script;

export default __exports__